module.exports = __webpack_public_path__ + "media/components/Card/tick-326cc96f06c7ff236b901b7848073fa0.png";